import React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert, ArrowLeft } from "lucide-react";

function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gradient-to-bl from-[#0f172a] via-[#1e1a78] to-[#0f172a] text-white p-4">
      <div className="text-center max-w-md">
        <ShieldAlert className="w-20 h-20 mx-auto mb-6 text-red-500" />
        <h1 className="text-3xl font-bold mb-4">Unauthorized Access</h1>
        <p className="text-xl mb-8">You are not authorized to access this page.</p>
        <button
          onClick={() => navigate(-1)}
          className="flex items-center justify-center mx-auto bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-md transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Go Back
        </button>
      </div>
    </div>
  );
}

export default UnauthorizedPage;